import { Controller } from "stimulus";
import { M } from "@materializecss/materialize/dist/js/materialize";

export default class extends Controller {
  connect() {
    this.update();
    window.addEventListener("hashchange", this.update.bind(this));
  }

  disconnect() {
    window.removeEventListener("hashchange", this.update.bind(this));
    this.instance.destroy();
  }

  update() {
    this.instance.updateTabIndicator();
  }

  get instance() {
    return M.Tabs.init(this.element, {});
  }
}
